<template>
  <btn flat @click="connect" :loading="loading" class="facebook-integration integration-btn">
    <facebook-icon class="icon" />
    <span v-if="login" v-t.preserve="'auth.facebook.signIn'" />
    <span v-else v-t.preserve="'auth.facebook.signUp'" />
  </btn>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import config from '@/config'
import peanutbutterAPI, { AuthenticationPlatform } from '@/api/peanutbutter'
import authenticationService from '@/js/AuthenticationService'
import recaptchaService from '@/js/RecaptchaService'

export default {
  name: 'facebook-integration-btn',
  props: {
    login: Boolean
  },
  data: () => ({
    loading: false
  }),
  methods: {
    ...mapActions({ signIn: 'authentication/signIn' }),
    ...mapMutations({ setFacebookEmail: 'authentication/SET_FACEBOOK_EMAIL' }),
    async connect() {
      this.loading = true
      let authenticated = await this.authenticate()
      if (!authenticated) {
        window.FB.login(this.authenticate, { scope: 'email' })
      } else {
        this.loading = false
      }
    },
    getLoginStatus() {
      return new Promise(resolve => window.FB.getLoginStatus(response => resolve(response)))
    },
    getFacebookEmail() {
      return new Promise(resolve => window.FB.api('/me?fields=email', response => resolve(response.email)))
    },
    async authenticate() {
      const response = await this.getLoginStatus()
      if (response.status !== 'connected') {
        this.loading = false
        return false
      }

      try {
        const email = await this.getFacebookEmail()
        if (email) {
          this.setFacebookEmail(email)
        }

        const recaptchaToken = await recaptchaService.getToken('login')
        const credentials = { accessToken: response.authResponse.accessToken }

        try {
          await peanutbutterAPI.signUp(credentials, { email }, AuthenticationPlatform.FACEBOOK, recaptchaToken)
        } catch {}

        await authenticationService.signIn({
          signInParameters: {
            credentials,
            authenticationPlatform: AuthenticationPlatform.FACEBOOK
          }
        })

        this.$emit('authenticated')
      } finally {
        this.loading = false
      }

      return true
    }
  },
  created() {
    window.FB.init({
      appId: config.facebookAppId,
      scope: 'email',
      return_scopes: true,
      xfbml: true,
      version: 'v6.0'
    })
  }
}
</script>

<style lang="scss" scoped>
button.btn.facebook-integration {
  background: #3168C8;
}
</style>
